import Fab from "@mui/material/Fab";

import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";

export default function NavigationButtons({
  handleRouteUpload,
  handleRouteFilter,
  handleSyncLocation,
}) {
  return (
    <div
      style={{
        height: "150px",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        position: "absolute",
        bottom: "50px",
        left: "30px",
      }}
    >
      <Fab onClick={handleRouteUpload} color="primary" aria-label="add">
        <AddIcon />
      </Fab>
      {/* <Fab onClick={handleRouteFilter} color="primary" aria-label="edit">
        <SearchIcon />
      </Fab> */}
      <Fab onClick={handleSyncLocation} color="primary" aria-label="gps">
        <GpsFixedIcon />
      </Fab>
    </div>
  );
}
